import type { BlockSpec } from '@blocksuite/block-std';
import type { GfxPrimitiveElementModel } from '@blocksuite/block-std/gfx';
import {
  EdgelessNoteBlockSpec,
  EdgelessSurfaceBlockSpec,
  EdgelessSurfaceRefBlockSpec,
  EdgelessTextBlockSpec,
  FrameBlockSpec,
  SurfaceBlockModel
} from '@blocksuite/blocks';
import type { Constructor } from '@blocksuite/global/utils';
import type { FrameworkProvider } from '@toeverything/infra';

import { CommonBlockSpecs } from './common';
import { PiqueMindmapElementModel } from './custom/pique/mindmap-element';
import { createEdgelessRootBlockSpec } from './custom/root-block';


export class PiqueSurfaceBlockModel extends SurfaceBlockModel {
  constructor() {
    super();
  }

  /** Override the element‑table and inject our mind‑map model. */
  protected override _extendElement(
    ctorMap: Record<
      string,
      Constructor<
        GfxPrimitiveElementModel,
        ConstructorParameters<typeof GfxPrimitiveElementModel>
      >
    >
  ): void {
    super._extendElement(ctorMap);

    // swap in our custom mind‑map element
    this._elementCtorMap['mindmap'] = PiqueMindmapElementModel as Constructor<
      GfxPrimitiveElementModel,
      ConstructorParameters<typeof GfxPrimitiveElementModel>
    >;
  }
}


(
  EdgelessSurfaceBlockSpec.schema
    .model as typeof EdgelessSurfaceBlockSpec.schema.model
).toModel = () => new PiqueSurfaceBlockModel();


export function createEdgelessModeSpecs(
  framework: FrameworkProvider
): BlockSpec[] {
  return [
    ...CommonBlockSpecs,
    EdgelessSurfaceBlockSpec,
    EdgelessSurfaceRefBlockSpec,
    FrameBlockSpec,
    EdgelessTextBlockSpec,
    EdgelessNoteBlockSpec,
    createEdgelessRootBlockSpec(framework),
  ];
}
